import React from 'react';

/**
 * Компонент секции дополнительных параметров ипотеки
 */
const AdditionalParametersSection = ({ formData, handleInputChange, errors }) => {
  return (
    <fieldset className="mb-8 border-b border-gray-200 dark:border-gray-700 pb-8">
      <legend className="text-xl font-medium text-gray-800 dark:text-gray-200 mb-5">Дополнительные параметры</legend>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
        {/* Тип ежемесячных платежей */}
        <div>
          <label htmlFor="paymentType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
            Тип ежемесячных платежей
          </label>
          <select
            id="paymentType" name="paymentType" value={formData.paymentType} onChange={handleInputChange}
            className={`form-select ${errors.paymentType ? 'input-error' : ''}`} required
            aria-invalid={!!errors.paymentType} aria-describedby="paymentType-error"
          >
            <option value="annuity">Аннуитетный (равными платежами)</option>
            <option value="differentiated">Дифференцированный (уменьшающийся)</option>
          </select>
          {errors.paymentType && (
            <p id="paymentType-error" className="mt-1 text-xs text-red-600 dark:text-red-400" role="alert">
              {errors.paymentType}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            {formData.paymentType === 'annuity' 
              ? 'Платёж равными частями на протяжении всего срока кредита.' 
              : 'Платёж уменьшается со временем, в начале выше, чем аннуитетный.'}
          </p>
        </div>

        {/* Тип ипотечной программы */}
        <div>
          <label htmlFor="creditType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
            Тип ипотечной программы
          </label>
          <select
            id="creditType" name="creditType" value={formData.creditType} onChange={handleInputChange}
            className="form-select" aria-describedby="creditType-hint"
          >
            <option value="standard">Стандартная (от 7.5%)</option>
            <option value="government">Господдержка 2020 (от 8.0%)</option>
            <option value="family">Семейная (от 6.0%)</option>
            <option value="far_east">Дальневосточная (от 2.0%)</option>
            <option value="it">IT-специалистам (от 5.0%)</option>
            <option value="agricultural">Сельская (от 3.0%)</option>
            <option value="military">Военная (от 7.0%)</option>
          </select>
          <p id="creditType-hint" className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Автоматически обновит ставку, если она была базовой.
          </p>
        </div>
      </div>
    </fieldset>
  );
};

export default AdditionalParametersSection;